import type { DownloadTreeNode } from '~/types/download'
import type { TocItemData } from '~/utils/literature/hierarchy-builder'
import type { BookAndArticle } from '~/utils/solr/literature'

interface MapBookTocToDownloadNodesParams {
  tocItems?: TocItemData[] | null
  book?: BookAndArticle | null
}

function buildDownloadId(bookId: string, item: TocItemData) {
  const parts = [bookId || 'book', item.id || item.pageNumberString || 'node']
  if (item.fragmentId) {
    parts.push(item.fragmentId)
  }
  return parts.filter(Boolean).join('#').toLowerCase()
}

export function mapBookTocToDownloadNodes({ tocItems, book }: MapBookTocToDownloadNodesParams): DownloadTreeNode[] {
  if (!tocItems?.length) {
    return []
  }

  let tocIndex = 0
  const bookId = book?.id ?? 'book'
  const authors = book?.authorName ?? book?.author ?? null
  const lastUpdated = book?.lastUpdatedByEditor ?? book?.timestamp ?? null

  const mapNode = (item: TocItemData): DownloadTreeNode => {
    const currentTocIndex = tocIndex++
    const children = item.children?.map(child => mapNode(child)) ?? []
    const hasPageNumber = Boolean(item.pageNumberString)

    return {
      id: item.id,
      downloadId: buildDownloadId(bookId, item),
      title: item.title,
      nodeType: 'book_section',
      type: 'book_section',
      source: book?.title ?? null,
      authors: authors ?? undefined,
      lastUpdated,
      tocIndex: currentTocIndex,
      selectable: hasPageNumber,
      payload: {
        kind: 'book',
        bookId,
        bookTitle: book?.title ?? null,
        bookSubtitle: book?.subtitle ?? null,
        authors: authors ?? null,
        fragmentId: item.fragmentId ?? null,
        pageNumber: item.pageNumberString ?? null,
        tocId: item.id,
        title: item.title,
        href: item.href ?? null,
      },
      children,
    }
  }

  return tocItems.map(mapNode)
}
